export default __webpack_public_path__ + "static/media/Group 11858.79700226.svg";